import React, { FC, useState } from 'react'
import { FlowManagerContext } from '../../../contexts'
import {
  useEffectOnce,
  useFlowContext,
  useSignupState,
  useRedirectToHpidLogin
} from '../../../hooks'
import { useHistory, useLocation } from 'react-router-dom'
import { FlowManager } from '../../../types'
import { LoadingPage } from '../LoadingPage'

export const FlowManagerProvider: FC = ({ children }) => {
  const flowContext = useFlowContext()
  const signupState = useSignupState()
  const {
    checkShouldRedirectToLogin,
    redirectToLogin
  } = useRedirectToHpidLogin()
  const [flowManager, setFlowManager] = useState<FlowManager>(undefined)
  const { stopBrowserBack, isHpIdValuePropPage } = flowContext.getOptions()
  const history = useHistory()
  const location = useLocation()

  const shouldRedirectToLogin = checkShouldRedirectToLogin(isHpIdValuePropPage)

  useEffectOnce(() => {
    if (shouldRedirectToLogin) {
      redirectToLogin()
    }

    ;(async () => {
      setFlowManager(await flowContext.createFlowManager(signupState))
    })()
  })

  useEffectOnce(() => {
    if (stopBrowserBack) {
      history.replace(location.pathname, { stopBrowserBack: true })
      history.push(location.pathname)

      const eventListener = ({ state }: PopStateEvent) => {
        if (state?.state?.stopBrowserBack) {
          history.goForward()
        }
      }
      window.addEventListener('popstate', eventListener)

      return () => {
        window.removeEventListener('popstate', eventListener)
      }
    }
  })

  if (flowManager) {
    return (
      <FlowManagerContext.Provider value={flowManager}>
        {children}
      </FlowManagerContext.Provider>
    )
  }

  return <LoadingPage />
}
